import { useState } from "react";
import { OpensearchCuratedSearch } from "../../../__generated__/graphql";
import CuratedInternalSearchPowerUserFilters from "../CuratedSearchFilters/PowerUserFilters/CuratedInternalSearchPowerUserFilters";
import classNames from "classnames";
import CiroButton, { CiroButtonStyleEnum } from "../../shared/CiroButton";

const CuratedSearchDesignPowerFilterContainer = ({
  filters,
  setFilters,
  setShowFilters,
}: {
  filters: OpensearchCuratedSearch | null | undefined;
  setFilters: (filters: OpensearchCuratedSearch) => void;
  setShowFilters: (showFilters: boolean) => void;
}) => {
  const [updatingFilters, setUpdatingFilters] = useState<
    OpensearchCuratedSearch | null | undefined
  >(filters);

  return (
    <div className={classNames("flex", "flex-col", "gap-4")}>
      <CuratedInternalSearchPowerUserFilters
        savedFilters={updatingFilters}
        setSavedFilters={setUpdatingFilters}
      />
      <div className={classNames("flex", "justify-end")}>
        <CiroButton
          analyticsField="Save filters for strategy"
          style={CiroButtonStyleEnum.LOUD}
          onClick={() => {
            if (updatingFilters) {
              setFilters(updatingFilters);
              setShowFilters(false);
            }
          }}
        >
          Save filters
        </CiroButton>
      </div>
    </div>
  );
};

export default CuratedSearchDesignPowerFilterContainer;
